<template>
  <v-toolbar
  color="primary"
  fixed
  dark
  app
  >
  <v-toolbar-title class="ml-0 pl-3">
    <v-toolbar-side-icon @click.stop="handleDrawerToggle"></v-toolbar-side-icon>
  </v-toolbar-title>
  <v-spacer></v-spacer>
<!--       <v-btn icon href="https://github.com/tookit/vue-material-admin">
        <v-icon>fa fa-github</v-icon>
      </v-btn> -->
      <v-btn icon @click="handleFullScreen()">
        <v-icon>fullscreen</v-icon>
      </v-btn>
      <v-menu offset-y origin="center center" :nudge-bottom="10" transition="scale-transition">
        <v-btn icon large flat slot="activator">
          <v-avatar size="30px">
            <img src="/static/avatar/avatar.jpg" alt="Avatar"/>
          </v-avatar>
        </v-btn>
        <v-list class="pa-0">
          <v-list-tile v-for="(item,index) in items" :to="!item.href ? { name: item.name } : null" :href="item.href" @click="deslogar()" ripple="ripple" :disabled="item.disabled" :target="item.target" rel="noopener" :key="index">
            <v-list-tile-action v-if="item.icon">
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>{{ item.title }}</v-list-tile-title>
            </v-list-tile-content>            
          </v-list-tile>
        </v-list>
      </v-menu>
    </v-toolbar>
  </template>
  <script>
// import NotificationList from '@/components/widgets/list/NotificationList';
import Util from '@/util';
import { mapGetters } from 'vuex';
import * as MutationTypes from '@/store/mutation-types';
import {http, httpLogin} from '../backend/vue-axios/axios';
import swal from 'sweetalert';
export default {
  name: 'app-toolbar',
  data: () => ({
    items: [
    {
      icon: 'fullscreen_exit',
      href: '#',
      title: 'Sair',
    }
    ],
    dados_logout: [],
  }),
  computed: {
    toolbarColor () {
      return this.$vuetify.options.extra.mainNav;
    },

    ...mapGetters({ currentUser: 'currentUser' })

  },
  methods: {
    handleDrawerToggle () {
      window.getApp.$emit('APP_DRAWER_TOGGLED');
    },
    handleFullScreen () {
      Util.toggleFullScreen();
    },

    deslogar(){
     http.get('logout')
     .then(response => {
      console.log(response.data);
      this.dados_logout = response.data;

      delete localStorage.token
      delete localStorage.email
      delete localStorage.name
      this.$store.dispatch('logout')
      this.$router.push('login')
    })
     .catch(error => {
      console.log();
    });
   }


 }
};
</script>

<style type="text/css">
.primary{
  background-color: #007c6f !important;
}
.primary--text{
  color: #007c6f !important;

}
</style>


// WEBPACK FOOTER //
// src/components/AppToolbar.vue